<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">机侧题库</Breadcrumb-item>
        <Breadcrumb-item>题目反馈</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search mex-search">
      <Form :show-message="false" label-position="top">
        <Row :gutter="16">
          <i-col :span="8">
            <Form-item label="处理状态">
              <Select v-model="queryParam.handleStatus" clearable placeholder="请选择状态">
                <Option value="PENDING">待处理</Option>
                <Option value="PROCESSING">处理中</Option>
                <Option value="DONE">已处理</Option>
                <Option value="REJECTED">不成立</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="反馈类型">
              <Select v-model="queryParam.feedbackType" clearable placeholder="请选择类型">
                <Option value="STEM_ERROR">题干错误</Option>
                <Option value="OPTION_ERROR">选项错误</Option>
                <Option value="AUDIO_ERROR">音频错误</Option>
                <Option value="IMAGE_ERROR">图片错误</Option>
                <Option value="ANSWER_ERROR">答案或解析错误</Option>
                <Option value="DISPLAY_ERROR">展示异常</Option>
                <Option value="OTHER">其他</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="测评类型">
              <Select v-model="queryParam.examType" clearable placeholder="请选择测评类型">
                <Option value="PLACEMENT">入门测</Option>
                <Option value="SUMMATIVE">阶段测</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="学员ID">
              <Input v-model="queryParam.uid" placeholder="uid"></Input>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="场次ID">
              <Input v-model="queryParam.sessionId" placeholder="sessionId"></Input>
            </Form-item>
          </i-col>
          <i-col :span="8">
            <Form-item label="题目编码">
              <Input v-model="queryParam.questionCode" placeholder="业务编码"></Input>
            </Form-item>
          </i-col>
        </Row>
        <div class="mex-search-actions">
          <Button type="primary" @click="search">搜索</Button>
          <Button style="margin-left:8px" :disabled="!selection.length" :loading="batchLoading" @click="batchOffline">批量下线</Button>
        </div>
      </Form>
    </div>
    <List ref="list" style="margin-top: 10px" :tableColumns="tableColumns" listUrl="/mex/feedback/list"
          :params="queryParam" :onLoading="onLoading" :reload="reload" @on-selection-change="selectionChange"></List>
    <Modal v-model="detailVisible" title="题目反馈" width="760">
      <div style="max-height:70vh;overflow-y:auto;padding-right:8px">
        <Form :label-width="100">
          <Form-item label="反馈ID">{{detail.id}}</Form-item>
          <Form-item label="提交时间">{{detail.gmtCreate}}</Form-item>
          <Form-item label="学员">{{detail.studentName}} / uid {{detail.uid}}</Form-item>
          <Form-item label="联系电话">{{detail.contactPhone || '—'}}</Form-item>
          <Form-item label="场次">{{examLabel(detail.examType)}} / {{detail.sessionId}}</Form-item>
          <Form-item label="题目">
            <a v-if="detail.questionCode" href="javascript:;" class="mex-feedback-qcode" @click.prevent="jumpToQuestion">{{detail.questionCode}}</a>
            <span v-else>—</span>
            · {{skillLabel(detail.skill)}} · 第{{detail.seq}}题
          </Form-item>
          <Form-item label="类型">{{typeLabel(detail.feedbackType)}}</Form-item>
          <Form-item label="内容">
            <p style="white-space:pre-wrap">{{detail.content}}</p>
          </Form-item>
          <Form-item label="截图" v-if="images.length">
            <img v-for="(src, idx) in images" :key="idx" :src="src" class="mex-feedback-img">
          </Form-item>
          <Form-item label="当前状态">{{statusLabel(detail.handleStatus)}}</Form-item>
          <Form-item label="处理方式">
            <Select v-if="canHandle" v-model="handleMethod" placeholder="结单必选" style="width:280px">
              <Option value="FIX_CONTENT">已改正文/选项/答案</Option>
              <Option value="FIX_ASSET">已替换音频或图片</Option>
              <Option value="OFFLINE">已下线题目</Option>
              <Option value="NO_ISSUE">题目无误</Option>
              <Option value="CONTACT">已联系学员/家长</Option>
              <Option value="OTHER">其他</Option>
            </Select>
            <span v-else>{{methodLabel(detail.handleMethod)}}</span>
          </Form-item>
          <Form-item label="处理人">{{detail.handlerName || '—'}}</Form-item>
          <Form-item label="处理时间">{{detail.handledAt || '—'}}</Form-item>
          <Form-item label="处理备注">
            <Input v-if="canHandle" v-model="handleRemark" type="textarea" :rows="3"
                   placeholder="结单必填，说明改了什么或为何不成立"></Input>
            <p v-else style="white-space:pre-wrap">{{detail.handleRemark || '—'}}</p>
          </Form-item>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="detailVisible = false">关闭</Button>
        <Button v-if="canHandle" @click="handle('PROCESSING')">处理中</Button>
        <Button v-if="canHandle" type="primary" @click="handle('DONE')">已处理</Button>
        <Button v-if="canHandle" @click="handle('REJECTED')">不成立</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { skillLabel } from './mex-question-type'

export default {
  name: 'MexFeedbackList',
  data () {
    return {
      searchLoading: false,
      batchLoading: false,
      reload: 0,
      detailVisible: false,
      queryParam: {},
      detail: {},
      handleRemark: '',
      handleMethod: '',
      selection: [],
      tableColumns: [
        { type: 'selection', width: 60, align: 'center' },
        { title: 'ID', key: 'id', width: 80, ellipsis: true },
        { title: '提交时间', key: 'gmtCreate', width: 160, ellipsis: true },
        { title: '学员', key: 'studentName', width: 120, ellipsis: true },
        { title: 'uid', key: 'uid', width: 90, ellipsis: true },
        { title: '场次', key: 'sessionId', width: 90, ellipsis: true },
        { title: '题目编码', key: 'questionCode', width: 160, ellipsis: true },
        { title: '技能', key: 'skill', width: 140, ellipsis: true, render: (h, p) => h('span', skillLabel(p.row.skill)) },
        {
          title: '类型',
          key: 'feedbackType',
          width: 140,
          ellipsis: true,
          render: (h, params) => h('span', this.typeLabel(params.row.feedbackType))
        },
        { title: '内容', key: 'content', width: 240, ellipsis: true },
        {
          title: '状态',
          key: 'handleStatus',
          width: 90,
          ellipsis: true,
          render: (h, params) => h('span', this.statusLabel(params.row.handleStatus))
        },
        {
          title: '处理方式',
          key: 'handleMethod',
          width: 140,
          ellipsis: true,
          render: (h, params) => h('span', this.methodLabel(params.row.handleMethod))
        },
        { title: '处理人', key: 'handlerName', width: 100, ellipsis: true },
        { title: '处理时间', key: 'handledAt', width: 160, ellipsis: true },
        {
          title: '操作',
          key: 'action',
          width: 100,
          render: (h, params) => {
            return h('Button', {
              props: { type: 'primary', size: 'small' },
              on: { click: () => this.openDetail(params.row) }
            }, '处理')
          }
        }
      ]
    }
  },
  computed: {
    canHandle () {
      let s = this.detail && this.detail.handleStatus
      return s === 'PENDING' || s === 'PROCESSING'
    },
    images () {
      let raw = this.detail && this.detail.imagesJson
      if (!raw) return []
      if (Array.isArray(raw)) return raw
      try {
        let parsed = JSON.parse(raw)
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        return []
      }
    }
  },
  methods: {
    onLoading (loading) {
      this.searchLoading = loading
    },
    statusLabel (code) {
      if (code === 'PENDING') return '待处理'
      if (code === 'PROCESSING') return '处理中'
      if (code === 'DONE') return '已处理'
      if (code === 'REJECTED') return '不成立'
      return code || ''
    },
    methodLabel (code) {
      let map = {
        FIX_CONTENT: '已改正文/选项/答案',
        FIX_ASSET: '已替换音频或图片',
        OFFLINE: '已下线题目',
        NO_ISSUE: '题目无误',
        CONTACT: '已联系学员/家长',
        OTHER: '其他'
      }
      return map[code] || code || '—'
    },
    typeLabel (code) {
      let map = {
        STEM_ERROR: '题干错误',
        OPTION_ERROR: '选项错误',
        AUDIO_ERROR: '音频错误',
        IMAGE_ERROR: '图片错误',
        ANSWER_ERROR: '答案或解析错误',
        DISPLAY_ERROR: '展示异常',
        OTHER: '其他'
      }
      return map[code] || code || ''
    },
    examLabel (code) {
      if (code === 'PLACEMENT') return '入门测'
      if (code === 'SUMMATIVE') return '阶段测'
      return code || ''
    },
    skillLabel,
    search () {
      this.selection = []
      this.reload = Date.now()
      this.$nextTick(() => this.$refs.list && this.$refs.list.search())
    },
    selectionChange (selection) {
      this.selection = selection || []
    },
    batchOffline () {
      let rows = this.selection || []
      if (!rows.length) {
        this.$Message.warning('请先勾选反馈')
        return
      }
      let ids = rows.map(r => r.id).filter(id => id != null)
      if (!ids.length) {
        this.$Message.warning('请先勾选反馈')
        return
      }
      this.$Modal.confirm({
        title: '批量下线',
        content: '将对勾选的 ' + ids.length + ' 条反馈：状态改为已处理、方式改为已下线题目，并同步下线对应题目。确认继续？',
        onOk: () => {
          this.batchLoading = true
          return this.$http.post('/mex/feedback/batchOffline', {
            ids: ids.join(','),
            handleRemark: '批量下线'
          }).then(res => {
            this.batchLoading = false
            if (res.status === 'ok') {
              let msg = (res.data && res.data.message) || '已批量下线'
              this.$Message.success(msg)
              this.selection = []
              this.search()
            } else {
              this.$Message.error(res.msg || '批量下线失败')
            }
          }).catch(() => {
            this.batchLoading = false
          })
        }
      })
    },
    jumpToQuestion () {
      let d = this.detail || {}
      let qid = d.questionId
      if (qid == null || qid === '') {
        this.$Message.warning('无法定位题目：缺少题头 ID')
        return
      }
      let bank = String(d.bank || '').toUpperCase()
      let path = ''
      if (bank === 'SPEAK') {
        path = '/mex/speak/questions'
      } else if (bank === 'COMP') {
        path = '/mex/comp/questions'
      } else if (d.skill === 'Speaking') {
        path = '/mex/speak/questions'
      } else if (d.skill) {
        path = '/mex/comp/questions'
      }
      if (!path) {
        this.$Message.warning('无法判断题库类型')
        return
      }
      let route = this.$router.resolve({ path: path, query: { id: String(qid) } })
      window.open(route.href, '_blank')
    },
    openDetail (row) {
      this.$http.post('/mex/feedback/detail', { id: row.id }).then(res => {
        if (res.status === 'ok' && res.data) {
          this.detail = res.data
          this.handleRemark = res.data.handleRemark || ''
          this.handleMethod = res.data.handleMethod || ''
          this.detailVisible = true
        } else {
          this.$Message.error(res.msg || '加载失败')
        }
      })
    },
    handle (status) {
      this.$http.post('/mex/feedback/handle', {
        id: this.detail.id,
        handleStatus: status,
        handleMethod: this.handleMethod,
        handleRemark: this.handleRemark
      }).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('已更新')
          this.detailVisible = false
          this.search()
        } else {
          this.$Message.error(res.msg || '处理失败')
        }
      })
    }
  }
}
</script>

<style lang="less">
@import './mex-search.less';

.mex-feedback-qcode {
  color: #2d8cf0;
  cursor: pointer;
}
.mex-feedback-qcode:hover {
  text-decoration: underline;
}
.mex-feedback-img {
  display: block;
  max-width: 320px;
  max-height: 180px;
  margin-bottom: 8px;
  object-fit: contain;
  background: #f8f8f9;
  border: 1px solid #e8eaec;
}
</style>



// WEBPACK FOOTER //
// MexFeedbackList.vue?60b84c02